<template>
  <kst-modal-select
    :class="Info.Dialog.Select.Class"
    :title="Info.Dialog.Select.Title"
    :width="600"
    @init="handleModal_Init"
    @submit="handleModal_Submit"
  >
    <template #search-result="{ userData }">
      <List
        :items="items"
        :userData="userData"
      />
    </template>
  </kst-modal-select>
</template>

<script>
import AxiosMixin from "../../../mixins/AxiosMixin.js";
import SnackbarMixin from "../../../mixins/SnackbarMixin.js";

import Info from "../SpInfo.js";

import List from "./SpSe_List.vue";

/**
 * flow (how to use):
 * 1. handle Init event, set and do show when needed
 * 2. handle Submit event
 */
export default {
  mixins: [AxiosMixin, SnackbarMixin],
  components: {
    List
  },
  props: {
    items: Array
  },
  data: () => ({
    Info: Info,
    selectedRow: null,
    warehouseId: null,
    getRelatedService: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  methods: {
    /*** public method ***/

    show(warehouseId, getRelatedService) {
      this.warehouseId = warehouseId;
      this.getRelatedService = getRelatedService;
      this.showFunc();
    },

    /*** by modal ***/

    handleModal_Init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_Submit(selected, loadRelated) {
      if (this.getRelatedService) {
        this.selectedRow = selected;
        const options = {
          warehouse: this.warehouseId,
          specialprice: this.$kst.Search.getValue(selected.ID)
        }
        const config = this.getRelatedService(options);
        loadRelated(config, this.handleModal_Submit_Success);
      }
      else {
        this.$emit(this.$kst.Enum.Event.Submit, selected);
        this.hideFunc();
      }
    },
    handleModal_Submit_Success(data) {
      this.$emit(this.$kst.Enum.Event.Submit, this.selectedRow, data);
      this.hideFunc();
    }
  }
}
</script>